export class FaqItem {

  public question:string = '';
  public answer:string = '';
  public id:string = '';
  public isMono:boolean = false;

  constructor(model?:any) {
    if (model && model.question && model.answer && model.id) {
      this.question = model.question;
      this.answer = model.answer;
      this.id = model.id;
      this.isMono = model.isMono  === 'Sim';
    }
    else{
         throw Error('Faq inválido');
    }
  }
}
